import React, { Component } from 'react'
import { config } from 'config/config'
import PlaceHolder from '../PlaceHolder'
import './FilterOrder.scss'

export default class FilterOrder extends Component {
    constructor(props) {
        super(props);
    }

    onChange(e) {
        this.props.renderClickOrderSelected(this.refs.filterOrder.value)
    }

    render() {
        return (
            <div className="CustomSelect">
                <select data-qa="filter_order_list" id="FilterOrderList" value={this.props.value != undefined ? this.props.value : <PlaceHolder width="px" px="132" />} onChange={this.onChange.bind(this)} ref='filterOrder' className="FilterResult__options__item__button FilterResult__options__item__button--order">
                    {config.ordinations.map(({value, name, id}) => <option value={value} id={id} key={value}>{name}</option>)}
                </select>
            </div>
        )
    }
}
